import React from "react";
import {
  useSpendingDemandSubCreditList,
} from "../../../../hooks";
import { numberToStingWithSpaces } from "../../../../../../utils/numberDisplayer";

interface CreditTotalRendererProps {
  spendingDemandId: string;
}

export const CreditTotalRenderer: React.FC<CreditTotalRendererProps> = ({
  spendingDemandId,
}) => {
  const { totalSubCredit, getAllQuery: subCreditQuery } =
    useSpendingDemandSubCreditList(spendingDemandId, {
      disableQuery: !spendingDemandId,
      pageSize: 0, // Get all subcredits without pagination
    });

  if (subCreditQuery.isLoading) {
    return <span style={{ color: "#999", fontSize: "0.8rem" }}>...</span>;
  }

  const totalCredited = totalSubCredit.totalAmount || 0;

  if (totalCredited === 0) {
    return <span style={{ color: "#999" }}>-</span>;
  }

  return <span>{numberToStingWithSpaces(totalCredited)}</span>;
};

export default CreditTotalRenderer;
